export default __webpack_public_path__ + "static/media/32.50dac334.jpg";